/**
 * @author Codex
 * @date 2026.03.11
 * @description 랜딩페이지 사업자 정보 푸터
 */
interface ILandingBusinessFooter {
  companyNumber?: string;
  mailOrderNumber?: string;
  companyName?: string;
  ceo?: string;
  serviceName?: string;
}

const LandingBusinessFooter = ({
  companyNumber,
  mailOrderNumber,
  companyName,
  ceo,
  serviceName = '사주톡톡',
}: ILandingBusinessFooter) => {
  return (
    <div className="landing-preview__business-footer">
      <p className="landing-preview__business-footer-line">
        사업자 번호 : {companyNumber?.trim() || '-'} | 통신판매번호 {mailOrderNumber?.trim() || '-'}
      </p>
      <p className="landing-preview__business-footer-line">
        사업자명 : {companyName?.trim() || '-'} | 서비스명 : {serviceName}
      </p>
      <p className="landing-preview__business-footer-line">
        대표자 : {ceo?.trim() || '-'}
      </p>
      <p className="landing-preview__business-footer-description">
        {serviceName}은 {companyName?.trim() || '-'}에서 운영하는 서비스입니다.
      </p>
    </div>
  );
};

export default LandingBusinessFooter;
